module.exports = __webpack_public_path__ + "static/media/sample-logo.0d3f391f.svg";